import { render, staticRenderFns } from "./transaction-iso-inbound.vue?vue&type=template&id=0d3d01a2&"
import script from "./transaction-iso-inbound.vue?vue&type=script&lang=js&"
export * from "./transaction-iso-inbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports